export default __webpack_public_path__ + "static/media/1.d1ed8bf7.jpg";